import { render, staticRenderFns } from "./goalConfig.vue?vue&type=template&id=001e386e&scoped=true"
import script from "./goalConfig.vue?vue&type=script&lang=js"
export * from "./goalConfig.vue?vue&type=script&lang=js"
import style0 from "./goalConfig.vue?vue&type=style&index=0&id=001e386e&prod&scoped=true&lang=less"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "001e386e",
  null
  
)

export default component.exports